<template>
    <div>
        <div id="app">
            <router-view :key="$route.fullPath" />
            <Confirm></Confirm>
            <message-confirm></message-confirm>
        </div>
    </div>
</template>

<script>
import Confirm from '@/components/partials/Confirm';
import { LOCALE_TOOL_TOKYU } from '@/config/constants';
import MessageConfirm from '@/components/partials/layout/MessageConfirm';
import { mapState } from 'vuex';

export default {
    components: {
        MessageConfirm,
        Confirm
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    mounted() {
        let language = 'ja';
        this.$i18n.locale = this.$cookies.get(LOCALE_TOOL_TOKYU) || language;
        let userInfo = localStorage.getItem('KB_DEV_CUSTOMER') ? JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER')) : null;
        if (userInfo) {
            this.$store.commit('auth/auth_success', { userInfo: userInfo });
        }
    }
};
</script>

<style lang="scss">
.v-loading-refresh {
    height: 100vh;
    position: fixed;
    top: 0;
    width: 100%;
}
.dashboard-login .header {
    position: relative;
    background-color: transparent;
}
button {
    .el-loading {
        &-mask {
            background-color: rgba(255, 255, 255, 0.5);
        }
        &-spinner {
            margin-top: -16px;
            .circular {
                width: 25px;
                height: 25px;
            }
        }
    }
}
</style>
